import { useItem } from '@/composables/item'
import { teamService } from '@/services/api'
import { defineStore, acceptHMRUpdate } from 'pinia'

export const useTeamStore = defineStore('team', () => {
	const { items, show, create, remove, update, getItem } = useItem<
		Api.Team,
		Api.TeamPostInput,
		Api.TeamUpdateInput
	>(teamService, 'teams')

	return {
		items,
		show,
		create,
		update,
		getItem,
		remove,
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useTeamStore, import.meta.hot))
}
